/* ============================================================
   Wyld Chics — Frequently bought together   (snippets/wc-fbt.liquid)

   The picks are rendered by Liquid from product.metafields.wyldchics.fbt
   (up to 3, sold-out ones already dropped). This script:
     1. hides picks already in the cart and shows the first two left
     2. keeps the total in step with the checkboxes
     3. Add selected: one /cart/add.js with every ticked variant, then
        the theme's own event so the drawer refreshes, then opens it
     4. a product with no picks yet (data-fallback) asks Shopify's
        recommendations endpoint and renders those instead
   The main product's variant is read from the buy form at click time,
   so a colour or length picked above is what gets added.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  // '/' on the English site, '/es/' on the Spanish one (Shopify sets it), so the drawer and links stay in the shopper's language
  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  var cartTotal = 0;   // what is in the cart now, so the milestone line is about the real order
  var cartHasCode = false;   // a percentage code would also cut the picks, so no free-shipping promise then
  function fetchCartIds() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartTotal = c.total_price || 0;
        cartHasCode = (c.discount_codes || []).some(function (d) { return d.applicable; });
        return c.items.map(function (i) { return String(i.product_id); });
      })
      .catch(function () { return []; });
  }

  function setup(root) {
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-wc-fbt-pick]'));
    var total = root.querySelector('[data-wc-fbt-total]');
    var addBtn = root.querySelector('[data-wc-fbt-add]');
    var err = root.querySelector('[data-wc-fbt-error]');

    function visibleRows() { return rows.filter(function (r) { return !r.hidden; }); }
    function show(row, on) {
      var id = row.getAttribute('data-wc-fbt-row');
      row.hidden = !on;
      var photo = root.querySelector('[data-wc-fbt-photo="' + id + '"]');
      var plus = root.querySelector('[data-wc-fbt-plus="' + id + '"]');
      if (photo) photo.hidden = !on;
      if (plus) plus.hidden = !on;
    }
    function recalc() {
      var mainTick = root.querySelector('[data-wc-fbt-main]');
      var sum = (!mainTick || mainTick.checked) ? (parseInt(root.getAttribute('data-main-price'), 10) || 0) : 0;
      visibleRows().forEach(function (r) {
        var t = r.querySelector('[data-wc-fbt-tick]');
        if (t && t.checked) sum += parseInt(t.getAttribute('data-price'), 10) || 0;
      });
      if (total) total.textContent = money(sum);
      milestone(sum);
    }
    /* the line after the total: only when this selection plus the cart clears
       free shipping. Nothing about the glue here (Jonathan, 2026-09-13: the
       glue is often one of the picks, so counting toward it reads wrong). */
    function milestone(sum) {
      var el = root.querySelector('[data-wc-fbt-ship]');
      if (!el) return;
      var ship = parseInt(root.getAttribute('data-ship-cents'), 10) || 0;
      var hit = ship > 0 && !cartHasCode && (cartTotal + sum) >= ship;
      el.textContent = hit ? (root.getAttribute('data-msg-ship') || '') : '';
      el.classList.toggle('is-hit', hit);
      el.hidden = !hit;
    }
    /* two picks, preferring ones not in the cart yet; a pick that is already
       in the cart still shows, marked and unticked, so the block never
       vanishes after Add selected (Jonathan asked, 2026-09-13) */
    function pickTwo(cartIds) {
      var shown = 0;
      var fresh = rows.filter(function (r) { return cartIds.indexOf(r.getAttribute('data-wc-fbt-row')) === -1; });
      var used = rows.filter(function (r) { return cartIds.indexOf(r.getAttribute('data-wc-fbt-row')) > -1; });
      rows.forEach(function (r) { show(r, false); });
      var precheck = root.getAttribute('data-precheck') === 'true';
      fresh.concat(used).slice(0, 2).forEach(function (r) {
        var inCart = used.indexOf(r) > -1;
        var wasInCart = r.classList.contains('is-in-cart');
        show(r, true); shown += 1;
        r.classList.toggle('is-in-cart', inCart);
        var t = r.querySelector('[data-wc-fbt-tick]');
        if (t) { t.disabled = inCart; if (inCart) t.checked = false; else if (wasInCart) t.checked = precheck; }   // taken out of the cart: tickable again
        var tag = r.querySelector('[data-wc-fbt-incart]');
        if (!tag) { tag = document.createElement('span'); tag.className = 'wc-fbt__incart'; tag.setAttribute('data-wc-fbt-incart', ''); tag.textContent = root.getAttribute('data-incart-label') || 'In your cart'; r.querySelector('.wc-fbt__name').appendChild(tag); }
        tag.hidden = !inCart;
      });
      // this product itself: once it is in the cart, Add selected should not add a second one by accident
      var mainRow = root.querySelector('[data-wc-fbt-row="main"]');
      var mainTick = root.querySelector('[data-wc-fbt-main]');
      var mainIn = cartIds.indexOf(root.getAttribute('data-product-id')) > -1;
      if (mainRow && mainTick) {
        mainRow.classList.toggle('is-in-cart', mainIn);
        mainTick.disabled = mainIn; mainTick.checked = !mainIn;
        var mt = mainRow.querySelector('[data-wc-fbt-incart]');
        if (!mt) { mt = document.createElement('span'); mt.className = 'wc-fbt__incart'; mt.setAttribute('data-wc-fbt-incart', ''); mt.textContent = root.getAttribute('data-incart-label') || 'In your cart'; mainRow.querySelector('.wc-fbt__name').appendChild(mt); }
        mt.hidden = !mainIn;
      }
      if (!rows.length) root.setAttribute('data-empty', ''); else root.removeAttribute('data-empty');
      recalc();
    }

    root.addEventListener('change', function (e) { if (e.target.matches('[data-wc-fbt-tick]')) recalc(); });

    addBtn.addEventListener('click', function () {
      var items = [];
      var form = document.querySelector('[data-product-root] form[data-product-form], form[data-product-form]');
      var sel = form && form.querySelector('[name="id"]');
      var mainId = (sel && sel.value) || root.getAttribute('data-main-variant');
      var mainTick = root.querySelector('[data-wc-fbt-main]');
      if (!mainTick || mainTick.checked) items.push({ id: Number(mainId), quantity: 1 });
      visibleRows().forEach(function (r) {
        var t = r.querySelector('[data-wc-fbt-tick]');
        if (t && t.checked) items.push({ id: Number(t.getAttribute('data-variant')), quantity: 1 });
      });
      if (!items.length) return;
      addBtn.setAttribute('aria-busy', 'true'); err.hidden = true;
      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: 'cart-items,cart-footer,cart-item-count', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) throw new Error(data.description || data.message || 'add failed');
          document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: { response: data } }));
          if (window.Alpine && Alpine.store && Alpine.store('modals')) Alpine.store('modals').open('cart');
          var label = addBtn.textContent;
          addBtn.textContent = root.getAttribute('data-added-label') || 'Added to your cart';
          setTimeout(function () { addBtn.textContent = label; }, 2500);
          fetchCartIds().then(pickTwo);
        })
        .catch(function (e) { err.hidden = false; if (window.console) console.warn('[wc-fbt]', e && e.message); })
        .then(function () { addBtn.removeAttribute('aria-busy'); });
    });

    /* cold start: Shopify's own recommendations (they also use purchase data) */
    function fallback() {
      var pid = root.getAttribute('data-product-id');
      var url = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || (routeRoot() + 'recommendations/products');
      return fetch(url + '.json?product_id=' + pid + '&limit=6&intent=related', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = root.querySelector('[data-wc-fbt-list]');
          var photos = root.querySelector('[data-wc-fbt-photos]');
          (data.products || []).filter(function (p) { return p.available; }).slice(0, 3).forEach(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
            if (!v) return;
            var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_300x$1$2') : '';
            var plus = document.createElement('span'); plus.className = 'wc-fbt__plus'; plus.setAttribute('data-wc-fbt-plus', p.id); plus.textContent = '+';
            var a = document.createElement('a'); a.className = 'wc-fbt__photo'; a.href = p.url; a.setAttribute('data-wc-fbt-photo', p.id); a.tabIndex = -1;
            if (img) { var im = document.createElement('img'); im.src = img; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
            photos.appendChild(plus); photos.appendChild(a);
            var li = document.createElement('li'); li.className = 'wc-fbt__row'; li.setAttribute('data-wc-fbt-row', p.id); li.setAttribute('data-wc-fbt-pick', ''); li.setAttribute('data-variant', v.id); li.setAttribute('data-price', v.price);
            var pre = root.getAttribute('data-precheck') === 'true';
            li.innerHTML = '<label class="wc-fbt__check"><input type="checkbox" ' + (pre ? 'checked ' : '') + 'data-wc-fbt-tick data-variant="' + v.id + '" data-price="' + v.price + '"><span class="wc-fbt__box" aria-hidden="true"></span><span class="wc-fbt__name"></span><span class="wc-fbt__price">' + money(v.price) + '</span></label>';
            var nameA = document.createElement('a'); nameA.href = p.url; nameA.textContent = p.title;
            li.querySelector('.wc-fbt__name').appendChild(nameA);
            list.appendChild(li);
            rows.push(li);
          });
        })
        .catch(function (e) { if (window.console) console.warn('[wc-fbt] recommendations', e && e.message); });
    }

    var ready = root.hasAttribute('data-fallback') ? fallback() : Promise.resolve();
    ready.then(fetchCartIds).then(pickTwo);

    /* the cart changes under this block (drawer stepper, remove, another tab's add): re-read it,
       so a pick taken out of the cart is tickable again and one just added shows "In your cart"
       (Jonathan, 2026-09-15: "thinks they're still there") */
    var syncTimer = null;
    function resync() { clearTimeout(syncTimer); syncTimer = setTimeout(function () { fetchCartIds().then(pickTwo); }, 150); }
    ['shapes:cart:update', 'shapes:cart:cartqtychange', 'shapes:cart:afteradditem'].forEach(function (n) { window.addEventListener(n, resync); });
    document.addEventListener('theme:cart-drawer:closing', resync);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) resync(); });
  }

  function init() { document.querySelectorAll('[data-wc-fbt]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
